export enum Currency {
  US_DOLLAR = "usd",
  AU_DOLLAR = "aud",
}
